import type { SwiperOptions } from 'swiper/types';

import React from 'react';
import Image from 'next/image';
import {
  Swiper,
  type SwiperClass,
  type SwiperRef,
  SwiperSlide,
} from 'swiper/react';

import { Box } from '@/components';

const SwiperBlog: React.FC<{
  images: any[];
  swiperRef: React.RefObject<SwiperRef | null>;
  handleSlideChange?: (event: SwiperClass) => void;
}> = ({ images, swiperRef, handleSlideChange }) => {
  const settings: SwiperOptions = {
    freeMode: true,
    loop: false,
    slidesPerView: 1,
    allowSlideNext: true,
    allowSlidePrev: true,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
  };

  return (
    <Box w="100%" maxW="350px" borderRadius={18} overflow="hidden">
      <Swiper
        spaceBetween={0}
        ref={swiperRef}
        watchSlidesProgress={true}
        dir="rtl"
        {...settings}
        onSlideChange={handleSlideChange}
      >
        {images?.map((image, id) => (
          <SwiperSlide key={id}>
            <Image
              src={image}
              alt="welcome"
              width={400}
              height={400}
              style={{
                width: '350px',
                height: '300px',
                objectFit: 'cover',
                borderRadius: 18,
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
export default SwiperBlog;
